/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Traces_TitleInputs */

const es_walkthrough_admin_traces_title = /** @type {(inputs: Walkthrough_Admin_Traces_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos del Sistema`)
};

const en_walkthrough_admin_traces_title = /** @type {(inputs: Walkthrough_Admin_Traces_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System Events`)
};

/**
* | output |
* | --- |
* | "System Events" |
*
* @param {Walkthrough_Admin_Traces_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_traces_title = /** @type {((inputs?: Walkthrough_Admin_Traces_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Traces_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_traces_title(inputs)
	return en_walkthrough_admin_traces_title(inputs)
});
export { walkthrough_admin_traces_title as "walkthrough.admin_traces_title" }